// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__rtInV","cardWrapper":"styles_cardWrapper__RVNLr","cardItem":"styles_cardItem__1HdIC","header":"styles_header__2y04T","main":"styles_main__1gFtN"};